/**
 * LangSync — keeps <html lang> in step with the active locale (WCAG 3.1.1),
 * N-3 (combined-CHECK §3 N-3).
 *
 * The prior module-eval side effect in lib/locale.ts read the store before
 * persist rehydration on production hard loads, so a visitor with a persisted
 * es/ht locale saw fully-translated content still tagged lang="en" — wrong
 * screen-reader pronunciation on the marquee trilingual capability. A mount
 * effect runs AFTER hydration + rehydration, and the store subscription keeps it
 * in sync on every subsequent locale change. Renders nothing.
 */
"use client";

import { useEffect } from "react";
import { useLocaleStore, CLDR_TAG } from "@/lib/locale";

export function LangSync() {
  const locale = useLocaleStore((s) => s.locale);
  useEffect(() => {
    document.documentElement.lang = CLDR_TAG[locale];
  }, [locale]);
  return null;
}
